<template>
  <div class="login" style="height: 100%">
    <div class="weui-form">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title">OpenP2P</h2>
      </div>
      <div class="weui-form__control-area" style="
          max-width: 500px;
          display: block;
          margin-left: auto;
          margin-right: auto;
        ">
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("reg.username") }}</label>
              </div>
              <div class="weui-cell__bd">
                <input v-model="username" autofocus="autofocus" class="weui-input" />
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("reg.password") }}</label>
              </div>
              <div class="weui-cell__bd">
                <input v-model="password" type="password" class="weui-input" />
              </div>
            </div>
            <div class="weui-form__opr-area">
              <a class="weui-btn weui-btn_primary" v-on:click="login" style="width: calc(100% - 64px)">{{ $t("login")
              }}</a>
            </div>
            <p>
              {{ $t("reg.noUser") }}
              <a class="weui-wa-hotarea weui-link" href="javascript:" v-on:click="this.$router.push('/register')">{{
                $t("reg.newUser") }}</a>
              {{ $t("reg.noAuth") }}
              <a class="weui-wa-hotarea weui-link" href="javascript:" v-on:click="this.$router.push('/forgot')">{{
                $t("reg.forgotPwd") }}</a>
            </p>
          </div>
        </div>
      </div>
      <div v-if="totalP2PConnect != 10" style="text-align: center">
        <span>{{ $t("total1") }}</span><span style="font-size: 2rem">{{ totalP2PConnect }}</span>
      </div>
      <div class="weui-form__extra-area">
        <div class="weui-footer">
          <p class="weui-footer__text">Copyright © 2024 openp2p.cn</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import weui from "weui.js"
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      totalP2PConnect: 0,
    }
  },
  props: {
    msg: String,
  },
  beforeMount() {
    window.debugLog(this.$store.state.token)
    window.debugLog(
      "token exp:",
      this.$store.state.token.exp,
      "now:",
      Date.now()
    )
    if (this.$store.state.token.exp * 1000 > Date.now()) {
      this.$router.push("/device")
    }
  },
  mounted() {
    this.getTotal()
    // setInterval(this.getTotal, 30000);
  },
  methods: {
    login() {
      let _this = this
      window.debugLog("vue login")
      axios
        .post(this.$ServerHost + "/api/v1/user/login", {
          user: this.$data.username,
          password: this.$data.password,
        })
        .then((response) => {
          if (response.status == 200 && response.data.error == 0) {
            localStorage.setItem("token", response.data.token)
            this.$store.commit(
              "setToken",
              JSON.parse(
                Buffer.from(response.data.token.split(".")[1], "base64")
              )
            )
            window.debugLog(
              "token:",
              JSON.parse(
                Buffer.from(response.data.token.split(".")[1], "base64")
              )
            )
            // window.debugLog('token:', this.$store.state.token)
            axios.defaults.headers.common["Authorization"] = response.data.token
            this.$router.replace(this.$route.query.redirect || "/device")
          } else {
            window.debugLog("login error:" + response)
          }
        })
        .catch(function () {
          weui.alert(_this.$t("loginError"), {
            buttons: [
              {
                label: _this.$t("ok"),
              },
            ],
          })
        })
    },
    getTotal() {
      axios.get(this.$ServerHost + "/api/v2/total").then((response) => {
        window.debugLog(response)
        if (response.status == 200) {
          this.$data.totalP2PConnect = response.data.num
        }
      })
    },
    onForgot() {
      weui.alert(this.$t("reg.forgotPwdDetail"), {
        buttons: [
          {
            label: this.$t("ok"),
          },
        ],
      })
    },
  },
}
</script>

<style scoped>
@import "../assets/css/weui.scss";
</style>

